{
  "version": 1,
  "asset_id": "32de3edd-3d81-4542-8993-9414da28bc37",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/32de3edd-3d81-4542-8993-9414da28bc37/hiatal-type-2-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/32de3edd-3d81-4542-8993-9414da28bc37/hiatal-type-2-v3-800.jpg",
  "original_filename": "hiatal-type-2-v3-800.jpg",
  "size": 137837,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T19:42:13Z"
}
